import React, { Component } from "react";
import { Wrapper, Card, CardBody, Row } from "app/NativeComponents/common";

import PartnerStat from "./PartnerStat";

class Stats extends Component {
  render() {
    //fix to give partners 50% commision on users added before Nov 1st 2019. This was because of a coding error before the date.
    let total_monthly_revenue = 0;
    total_monthly_revenue =
      parseFloat(this.props.partner_stats.enterprise_monthly_revenue / 100) *
        parseFloat(this.props.partner_stats.percent_enterprise) +
      parseFloat(this.props.partner_stats.total_monthly_revenue / 100) *
        parseFloat(this.props.partner_stats.percent);

    return (
      <Wrapper>
        <Card>
          <CardBody>
            <Row
              style={{
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <PartnerStat
                number={this.props.partner_stats.total_user_count}
                text={`All-Time User Sign Ups`}
                device={this.props.device}
                colors={this.props.colors}
              />
              <PartnerStat
                number={this.props.partner_stats.free_trial_subscribers}
                text={`Current Active Free Trials`}
                device={this.props.device}
                colors={this.props.colors}
              />
              <PartnerStat
                number={this.props.partner_stats.total_monthly_subscribers}
                text={`Current Monthly Subscribers`}
                device={this.props.device}
                colors={this.props.colors}
              />
              <PartnerStat
                number={
                  "$" +
                  (!Number.isNaN(total_monthly_revenue)
                    ? total_monthly_revenue.toFixed(2)
                    : "0.00")
                }
                text={`Current Monthly Revenue`}
                device={this.props.device}
                colors={this.props.colors}
              />
            </Row>
          </CardBody>
        </Card>
      </Wrapper>
    );
  }
}

export default Stats;
